import { Event } from "@markit/common.types";
import { Colors } from "../../../utils/colors";
import { getThumbnailImageUrl } from "@markit/common.utils";
import { useSelector } from "react-redux";
import { getAccountState } from "../../../redux/slices/accountSlice";
import { InitialsPic } from "../../InitialsPic";

type FormProfileItemImageProps = {
  item: Event;
  size: number;
};

export const FormProfileItemImage = ({
  item,
  size,
}: FormProfileItemImageProps) => {
  const { fullName } = useSelector(getAccountState).account.accountData;

  const styles = {
    imagePreview: {
      height: size,
      width: size,
      borderRadius: 8,
      backgroundColor: Colors.WHITE,
      border: `0.5px solid ${Colors.GRAY2}`,
    },
    imageItem: {
      border: `0.5px solid ${Colors.GRAY2}`,
      borderRadius: size / 1.8,
      height: size / 1.8,
      width: size / 1.8,
    },
  };

  return (
    <div className="Centering" style={styles.imagePreview}>
      {getThumbnailImageUrl(item) ? (
        <img
          src={getThumbnailImageUrl(item)}
          alt="ProfileFormImage"
          style={{
            ...styles.imageItem,
            objectFit: "cover",
            overflow: "hidden",
          }}
        />
      ) : (
        <div
          className="Centering"
          style={{
            ...styles.imageItem,
            backgroundColor: Colors.GRAY13,
          }}
        >
          <InitialsPic fullName={fullName} size={10} pointer={false} />
        </div>
      )}
    </div>
  );
};
